import VueCqrs from '@cqrs/vue-component-cqrs';
import * as q from '@Quest/Financials/Capex/Domain/queries';
import { Component } from 'vue-facing-decorator';

@Component
export default class CapexQueries extends VueCqrs
{
	runCapexAccountByIdQueryV1(workspaceId: number, strategyId: string, capexId: string)
	{
		const query = q.buildCapexAccountByIdQueryV1(workspaceId, strategyId, capexId);
		this.$query(query);
	}

	runCapexAccountsByStrategyIdQueryV1(workspaceId: number, strategyId: string)
	{
		const query = q.buildCapexAccountsByStrategyIdQueryV1(workspaceId, strategyId);
		this.$query(query);
	}

	runCapexAccountsByPortfolioIdQueryV1(workspaceId: number, portfolioId: string)
	{
		const query = q.buildCapexAccountsByPortfolioIdQueryV1(workspaceId, portfolioId);
		this.$query(query);
	}
}